import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";
import LoginService from '../../APIService/loginservice';
import { Image } from "@fluentui/react-components";
import { useForm } from 'react-hook-form';
import { authentication } from "@microsoft/teams-js";
import { CommonInfo } from "../../CommonData/Config";
import ToastrService from '../toaster/ToastrService';
import { makeStyles, shorthands, Spinner } from "@fluentui/react-components";
import * as microsoftTeams from "@microsoft/teams-js";
import GetSettingsService from '../../APIService/mySettingsService';
import { getSettings } from "../../viewmodel/getsettings";
import { isInTeams } from "../../utils/platform";
import { useTeamsContext } from "../../utils/useTeamsContext";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    container: {
        "> div": { ...shorthands.padding("20px") },
    },
});

const Commondata = CommonInfo;

const Login = () => {
    const {t} = useTranslation();
    const {
        register,
        handleSubmit,
        formState: { errors, isValid },
        control: { _formValues }
    } = useForm();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [emailError, setEmailError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [authToken, setAuthToken] = useState<string | null>(null);
    const [LoguserName, setLogUserName] = useState<string | null>(null);
    const [showAnotherComponent, setShowAnotherComponent] = useState(false);
    const styles = useStyles();
    const [isHidden, setIsHidden] = useState(true);
    const [urlInputType, setUrlInputType] = useState(true);
    const emailRef = useRef<HTMLInputElement>(null);
    const passwordRef = useRef<HTMLInputElement>(null);
    const btnRef = useRef<HTMLInputElement>(null);
    const navigate = useNavigate();
    const { inTeams, themeString } = useTeamsContext();

    useEffect(() => {
        // Update localStorage whenever themeString changes
        localStorage.setItem('Theme', themeString);
    }, [themeString]);

    useEffect(() => {
        const loggedInItem = localStorage.getItem('loggedIn');
        if (loggedInItem && JSON.parse(loggedInItem) === true) {
            const currentUrl = localStorage.getItem('currentUrl');
            if (currentUrl) {
                navigate(currentUrl);
            }
        } else {
            Commondata.resetValues();
        }
        submitUrl()
    }, []);

    let urlParams: any, userDataJSON: any;

    const showConsentDialog = async (url: any) => {
        if (inTeams) {
            authentication.authenticate({
                url: url,
                width: 600,
                height: 535,
                isExternal: false
            }).then(async (result) => {
                await convertToJSON(result);
            }).catch(async (error) => {
                await consentFailure(error)
            });
        } else {

        }
    }


    const convertToJSON = async (dataString: string): Promise<Record<string, string>> => {
        const pairs = dataString.split('&');
        const jsonData: Record<string, string> = {};
        pairs.forEach((pair: string) => {
            const [key, value] = pair.split('=');
            jsonData[key] = decodeURIComponent(value.replace(/\+/g, ' '));
        });

        if (jsonData['auth_key']) {
            localStorage.setItem('authToken', jsonData['auth_key']);
            localStorage.setItem('userId', jsonData['userId'] || '');
            localStorage.setItem('userEmail', jsonData['emailId'] || '');
            localStorage.setItem('UserName', jsonData['name'] || '');
            Commondata.authToken = jsonData['auth_key'];
            localStorage.setItem('loggedIn', 'true');
            try {
                const getDataResult = await GetSettingsService.getMySettings(jsonData['userId'], jsonData['emailId']);
                if (getDataResult.data.d) {
                    getSettingsData.data = getDataResult.data.d;
                    CommonInfo.workingDays = getDataResult.data.d.WorkingDays
                    const workingdaysString = JSON.stringify(getSettingsData.data.WorkingDays);
                    localStorage.setItem('Workingdays', JSON.stringify(getSettingsData.data.WorkingDays));
                    localStorage.setItem('Firstdayofweek', getDataResult.data.d.FirstDayOfWeek);
                    navigate('/workplace');


                }
            } catch (error) {
            }
        } else {
            console.error("auth_key is undefined.");
        }

        return jsonData;
    };
    const getSettingsData = getSettings;

    const consentFailure = async (reason: string) => {
        console.error("Consent failed: ", reason);
    }

    const submitUrl = () => {
        let Url;
        // window.location.hostname === "localhost" || window.location.hostname === "rxo365.xenovex.com" ? Url = 'saas2staging.rx-cloud.com' : Url = window.location.hostname;

        //V2 Development
        window.location.hostname === "localhost" || window.location.hostname === "rxo365.xenovex.com" ? Url = 'atlasdevuksouth1-htakdqhnd7fgguan.uksouth-01.azurewebsites.net' : Url = window.location.hostname;
        const https = ('https://' + Url)
        localStorage.setItem('tenantUrl', https);
        // ssoLogin()


        localStorage.setItem('isSSO', 'false');
        setUrlInputType(false);

    }

    const ssoLogin = async () => {
        try {
            const getDataResult = await LoginService.login('mailto:test@rx-cloud.com', 'No Password');
            if (getDataResult.data) {
                // localStorage.setItem('tenantUrl', _formValues.ssourl);
                const ssoUrl = localStorage.getItem('tenantUrl') + '/Account/Index';
                validateSso(ssoUrl);
            }
        } catch (error) {
            console.error('Error in login:', error);
            ToastrService.error(t('UrlError'));
        }
    }

    const validateSso = async (ssoUrl: any) => {
        const getValidateSsoResult = await LoginService.validateSSO(ssoUrl);
        if (getValidateSsoResult.request.responseURL && getValidateSsoResult.request.responseURL.endsWith('SsoConsumer/RequestSSO')) {
            // const url = localStorage.getItem('tenantUrl') + '/officeapp/sso.html?auth_start=1';
            // const url = 'https://rxo365.xenovex.com/officeapp/sso.html?auth_key=f1c3c944-8941-48d1-92a1-8536bed92941&expiresOn=2024-04-29%2017:52&name=Krishnakanth%20s&emailId=krishnakanth.s@xenovextech.com&userId=969';
            // const authToken = localStorage.getItem('tenantUrl') + '/Account/Index?RedirectUrl=/?oapp=1';
            // const url = 'https://rxo365.xenovex.com/officeapp/sso.html?auth_key=5d3e56fe-8ca9-47b4-bec7-bd9bb09779a2&expiresOn=2025-02-17%2011:05&name=Thiagarajan%20R&emailId=thiagarajan.r@xenovextech.com&userId=15478';
            const url = 'https://localhost:53000/sso.html?auth_key=c0bde751-8e7c-47af-82c3-455c94dd00b6&expiresOn=2025-03-20%2012:24&name=Krishnakanth%20S&emailId=krishnakanth.s@xenovextech.com&userId=969'
            // await convertToJSON("auth_key=7dd7b6a2-bfbf-44f5-adbd-89a96a5fb4d9&expiresOn=2024-04-29%2017:52&name=Krishnakanth%20s&emailId=krishnakanth.s@xenovextech.com&userId=969");

            // Commondata.configurl = url
            // navigate('/auth-start');
            showConsentDialog(url);
            setIsHidden(false);
            // setUrlInputType(false); 
        } else {
            localStorage.setItem('isSSO', 'false');
            setUrlInputType(false);
            setIsHidden(true);
            // navigate('/login');
        }
    }

    const handleEnterKey = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            const currentInputRef =
                event.currentTarget === emailRef.current
                    ? emailRef
                    : event.currentTarget === passwordRef.current
                        ? passwordRef
                        : null;

            if (currentInputRef) {
                const inputValue = currentInputRef.current?.value.trim();

                if (!inputValue) {
                    if (currentInputRef === emailRef) {
                        setEmailError(t('PleaseEnterYourEmail'));
                    } else if (currentInputRef === passwordRef) {
                        setPasswordError(t("PleaseEnterYourPassword"));
                    }

                    currentInputRef.current?.focus();
                    return;
                }
            }
            setEmailError("");
            if (event.currentTarget === passwordRef.current && btnRef.current) {
                btnRef.current.click();
            } else if (event.currentTarget === emailRef.current && passwordRef.current) {
                passwordRef.current.focus();
            } else if (btnRef.current) {
                btnRef.current.click();
            }
        }
    };


    const onSubmit = async () => {
        try {
            //SSO Handling
            if (localStorage.getItem('authToken')) {
                // setAuthToken(authToken);
                // setLogUserName(LoguserName);
                // setShowAnotherComponent(true);
                navigate('/workplace');
                return;
            }
            const getDataResult = await LoginService.login(_formValues.email, _formValues.password);
            const authToken1 = getDataResult.data.AuthToken;
            // const authToken1 = 'f0681fda-6314-47a4-a706-2bb43688beb2';
            const LoguserName = getDataResult.data.UserName;
            localStorage.setItem('loggedIn', 'true');
            localStorage.setItem('userEmail', _formValues.email);
            localStorage.setItem('userId', getDataResult.data.UserId);
            localStorage.setItem('UserName', getDataResult.data.UserName);

            if (authToken1) {
                // setAuthToken(authToken1);
                localStorage.setItem('authToken', authToken1);
                Commondata.authToken = authToken1;
                setLogUserName(LoguserName);
                try {
                    const getUserResult = await GetSettingsService.getMySettings(getDataResult.data.UserId, _formValues.email);
                    if (getUserResult.data.d) {
                        getSettingsData.data = getUserResult.data.d;
                        CommonInfo.workingDays = getUserResult.data.d.WorkingDays
                        const workingdaysString = JSON.stringify(getSettingsData.data.WorkingDays);
                        localStorage.setItem('Workingdays', JSON.stringify(getSettingsData.data.WorkingDays));
                        localStorage.setItem('Firstdayofweek', getUserResult.data.d.FirstDayOfWeek);
                        navigate('/workplace');


                    }
                } catch (error) {
                }
                // setShowAnotherComponent(true);
                navigate('/workplace');
            }
            else {
                // alert("Invalid Email or Password!!")
                // setEmail('');
                // setPassword('');
                setEmailError(t("InvalidCredentials"));
                // setPasswordError("Invalid password");
                // if (emailRef.current) {
                //     emailRef.current.focus();
                // }

            }
        } catch (error) {
            console.error('Error in login:', error);
        }
    };

    const theme = localStorage.getItem('Theme')

    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)} className="mb-0">
                <div>
                    {urlInputType && (
                        <div className={themeString === 'dark' ? 'mainContainer_dark' : "mainContainer"}>
                            <h2>{t('ResourceXpress')}</h2>
                            <div className={"titleContainer mb-5 mt-2"}>
                                <Image id="logoimg" src={Commondata.folderName + "RXlogo.png"} />
                            </div>
                        </div>)}
                    {!urlInputType && (
                        <div className={themeString === 'dark' ? 'mainContainer_dark' : "mainContainer"}>
                            <h2>{t('ResourceXpress')}</h2>
                            <div className={"titleContainer mb-5 mt-2"}>
                                <Image id="logoimg" src={Commondata.folderName + "RXlogo.png"} />
                                {/* <div id="title">Login</div> */}
                            </div>
                            <label className="mb-4" style={{ fontWeight: "600", fontSize: "19px" }}  >{t('EnterYourDetailsBelow')}</label>
                            <div className="row mt-1">
                                <div className={"inputContainer "}>
                                    <label className={"labelname mb-2"} htmlFor="mail">{t('EmailAddress')}</label>
                                    <input
                                        id="mail" autoFocus={true}
                                        type="text"
                                        placeholder={t('EmailAddress')}
                                        {...register("email", {
                                            required: true,
                                            pattern: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/
                                        })}
                                        onKeyDown={handleEnterKey}
                                        className={`${themeString === 'dark' ? 'input-Box_dark ' : "input-Box"} ${(errors.email && (errors.email.type === 'required' || errors.email.type === 'pattern')) ? 'errorLabel' : ''}`}
                                    />
                                    {errors.email && errors.email.type === "required" && (
                                        <span className="errorText mt-2">{t('TheEmailIdFieldIsRequired')} </span>
                                    )}
                                    {errors.email && errors.email.type === "pattern" && (
                                        <span className="errorText mt-2">{t('PleaseEnterValidEmailAddress')}</span>
                                    )}
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className={"inputContainer"}>
                                    <label className={"labelname mb-2 "} htmlFor="password">{t('Password')}</label>
                                    <input
                                        id="password"
                                        type="password"
                                        placeholder={t('Password')}
                                        {...register("password", {
                                            required: true,
                                        })}
                                        onKeyDown={handleEnterKey}
                                        className={`${themeString === 'dark' ? 'input-Box_dark ' : "input-Box"} ${(errors.password && (errors.password.type === 'required' || errors.password.type === 'pattern')) ? 'errorLabel' : ''}`}
                                    />
                                    {errors.password && errors.password.type === "required" && (
                                        <span className="errorText mt-2">{t('ThePasswordFieldIsRequired')}</span>
                                    )}
                                </div>
                            </div>
                            <label className="errorText mt-2">{emailError}</label>

                            <div className="row mt-3">

                                <div className={"inputContainer"}>
                                    <input
                                        id="btn"
                                        className={"inputButton"}
                                        type="submit"
                                        value={t('LogIn')}
                                        ref={btnRef}
                                    />
                                </div>
                                
                            </div>
                            <div className="row">
                                {/* <label className={"textleft mt-3"} htmlFor="mail">Forgot Password?</label> */}
                            </div>
                        </div>
                    )}
                </div>
            </form>
            {ToastrService.getToastrComponent()}
            {/* {showAnotherComponent && <Sidenav authToken={authToken} LoguserName={LoguserName} />} */}
        </div>
    );
}

export default Login

